import React, { useState } from "react";
import { useTranslation } from "react-i18next";

interface ItemConversaProps {
  titulo: string;
  aoExcluir: () => void;
}

// Conteúdo de uma conversa no menu lateral (dentro do ItemSub da empreender-ui): o título e a
// lixeira, com confirmação na própria linha. O ItemSub já é um <button>, então as ações são
// spans com role="button", e todo clique nelas para aqui, sem abrir a conversa.
const ItemConversa: React.FC<ItemConversaProps> = ({ titulo, aoExcluir }) => {
  const { t } = useTranslation();
  const [confirmando, setConfirmando] = useState(false);

  const acao = (fazer: () => void) => ({
    role: "button",
    tabIndex: 0,
    onClick: (e: React.MouseEvent) => {
      e.stopPropagation();
      fazer();
    },
    onKeyDown: (e: React.KeyboardEvent) => {
      if (e.key !== "Enter" && e.key !== " ") return;
      e.preventDefault();
      e.stopPropagation();
      fazer();
    },
  });

  if (confirmando) {
    return (
      <span className="item-conversa confirmando" onClick={(e) => e.stopPropagation()}>
        <span className="item-conversa-titulo">{t("excluir_pergunta")}</span>
        <span className="item-conversa-acoes">
          <span className="item-conversa-sim" {...acao(aoExcluir)}>
            {t("excluir_sim")}
          </span>
          <span className="item-conversa-nao" {...acao(() => setConfirmando(false))}>
            {t("excluir_nao")}
          </span>
        </span>
      </span>
    );
  }

  return (
    <span className="item-conversa">
      <span className="item-conversa-titulo">{titulo}</span>
      <span
        className="item-conversa-lixeira"
        aria-label={t("excluir_conversa")}
        title={t("excluir_conversa")}
        {...acao(() => setConfirmando(true))}
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M3 6h18" />
          <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
          <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
        </svg>
      </span>
    </span>
  );
};

export default ItemConversa;
